// Lote V-9 — Landing tras checkout exitoso de kit LeyroSpot.
// Stripe redirixe aquí coa session_id; non chamamos a Stripe nin
// confirmamos nós nada — o webhook xa rexistrou HardwareOrder. Esta
// páxina só dá feedback ao usuario e leva ao listado de pedidos.

import { CheckCircle2, Package } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import ContentPage from '../components/ui/ContentPage';

export default function ShopSuccessPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <ContentPage title={t('shopSuccess.title')} category={t('shop.category')}>
      <section className="not-prose flex flex-col items-center text-center gap-4 py-8">
        <div className="w-16 h-16 rounded-full bg-green-100 text-green-700 flex items-center justify-center">
          <CheckCircle2 size={36} />
        </div>
        <p className="text-base text-dark font-medium max-w-md">{t('shopSuccess.body')}</p>
        <p className="text-sm text-muted max-w-md">{t('shopSuccess.delivery')}</p>
        <Link
          to="/marketplace/shop"
          className="mt-4 inline-flex items-center gap-2 bg-rauxa text-white px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-rauxa/90"
        >
          <Package size={16} /> {t('shopSuccess.viewOrders')}
        </Link>
      </section>
    </ContentPage>
  );
}
